import GraphsResponse from 'src/models/graphs';

export const GraphsData: GraphsResponse = {
  titles: ['Test 1'],
  times: [['10:00', '10:10', '10:20']],
  temperatures: [[20, 21, 22]],
  pressures: [[12, 13, 14]],
  ambient_pressures: [[1000, 1000, 1000]],
};
